import React, { useEffect } from 'react';
import './LegalPage.css';
import { ArrowLeft } from 'lucide-react';
import LandingNavbar from '../components/layout/LandingNavbar';

const TermsOfService = ({ onNavigate, company }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-section-wrapper">
      <LandingNavbar company={company} onNavigate={onNavigate} view="terms" />
      <div className="legal-container">
        <button className="legal-back-btn" onClick={() => onNavigate('home')}>
          <ArrowLeft size={16} />
          Back to Home
        </button>

        <div className="legal-header">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: April 17, 2026</p>
        </div>

        <div className="legal-section">
          <h2>1. Plain English, Clear Rules</h2>
          <p>
            Welcome to BharatQA. This document outlines the rules for using our platform. We've written it without the heavy legal jargon, but these terms do form a binding agreement between you and BharatQA when you use our services.
          </p>
        </div>

        <div className="legal-section">
          <h2>2. For App Developers (Clients)</h2>
          <p>We are a testing facilitation platform. By uploading your application to BharatQA:</p>
          <ul>
            <li><strong>Live & Production Testing:</strong> Testers will often be using their own real credentials (e.g., signing up with their own phone numbers or emails) to test your app. You acknowledge that BharatQA is not liable if a tester accidentally or intentionally modifies live data, exploits a bug, or affects your production metrics.</li>
            <li><strong>No Liability for Outcomes:</strong> While we strive to provide excellent QA insights, we are not liable for bugs that make it to production, server downtime, or issues arising from testing activities on our platform.</li>
            <li><strong>Right to Refuse Service:</strong> We reserve the right to remove any application from our platform if it violates safety policies, contains malicious code, or is otherwise deemed inappropriate.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>3. For QA Testers</h2>
          <p>As a tester on the BharatQA platform, you are acting as an independent freelancer:</p>
          <ul>
            <li><strong>Personal Responsibility:</strong> You are often testing real apps using your own devices and your own accounts. You are entirely responsible for the data you choose to share (such as phone numbers or emails) with the apps you test.</li>
            <li><strong>Quality Feedback:</strong> You agree to provide honest, original feedback and conduct tests manually as requested. The use of bots, emulators, or falsified recordings is strictly prohibited.</li>
            <li><strong>Confidentiality:</strong> You agree not to distribute, screenshot, reverse-engineer, or publicly share any parts of the applications you test.</li>
            <li><strong>Payout Conditions:</strong> Compensation is based strictly on the approval of your test submissions by our system or the client. Low-effort or fraudulent reports will be rejected without payment.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>4. Limitation of Liability</h2>
          <p>
            We built BharatQA to help teams ship better code, but software is unpredictable. To the maximum extent allowed by law, BharatQA and its team provide the service "as is" and are not liable for incidental, indirect, or consequential damages (including loss of profits or data) arising from using our platform.
          </p>
        </div>

        <div className="legal-section">
          <h2>5. Account Termination</h2>
          <p>
            We aim to maintain a professional, secure platform. We may suspend or terminate your account if we discover fraudulent activity, a breach of confidentiality, or abusive behavior toward our staff or users.
          </p>
        </div>

      </div>
    </div>
  );
};

export default TermsOfService;
